import React from "react";
import styles from "./loader.module.scss";
import { Loader as NorthstarLoader } from "@fluentui/react-northstar";
import classNames from "classnames";

interface LoaderProps {
    text: string;
    additionalClassName?: string;
}

const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
    return (
        <div className={classNames(styles.wrapper, props.additionalClassName)}>
            <NorthstarLoader title={props.text} label={props.text} />
        </div>
    );
};

export default Loader;
